import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { setRoom, cleanRoomSelection } from 'redux/actions';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import colors from 'constants/colors';
import { Container } from './styles';
import { CrossIcon, UndoIcon, HighIcon, CriticalIcon } from 'assets/icons';

const AlertItem = ({
  mobile,
  markRoomAlertAsRead,
  markRoomAlertAsUnread,
  alertId,
  roomNumber,
  groupId,
  priority,
  description,
  type,
  originator,
  createdAt,
  isRead,
  setAlerts
}) => {

  const navigate = useNavigate();
  //const dispatch = useDispatch()

  const colorMap = {
    'STAYOVER': colors.orange,
    'INFO': colors.purple,
    'GUEST_CHECKED_IN': colors.green,
    'GUEST_CHECKED_OUT': colors.darkGrey,
    'GUEST_CANCELLED': colors.red,
    'ASSISTANT_REQUESTED': colors.red,
    'ROOM_CLEANING_REQUIRED': colors.red,
    'BOOKING_ROOM_CHANGED': colors.red,
    'ERROR': colors.red,
    'BOOKING_CREATED': colors.blue,
    'default': colors.darkGrey
  }

  return (
    <Container
      mobile={mobile}
      color={colorMap[type]?? colorMap['default']}
      isRead={isRead}
    >
      <div
        className='alertBody'
        onClick={(event) => {
          if (event.metaKey || event.ctrlKey) {
            // Open new tab with absolute URL
            if(groupId) {
              window.open(`https://pms.rookhotel.com/booking-details/${groupId}`, '_blank', 'noopener,noreferrer')
            }
          } else {
            // Normal navigation
            if(groupId) {
              navigate(`/booking-details/${groupId}`)
            }
          }
        }}
      >
        <div className='alertContent'>
          <div className='alertTitle'>
            <span className='alertType'>{type?.replaceAll('_', ' ')}</span>
            {roomNumber && <span className='roomNumber'>{'Room ' + roomNumber}</span>}
          </div>
          <div className='alertDetails'>
            <div className='description'>{description}</div>
            <div className='alertInfo'>
              <span className='originator'>{originator}</span>
              <span className='dateTime'>{moment(createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}</span> 
            </div>
          </div>
        </div>
        <div className='priority'>
          {priority==="HIGH"? <HighIcon />: priority==="CRITICAL"? <CriticalIcon />: null}
        </div>
      </div>
      {
        isRead? (
          <div
            className='link'
            onClick={(event) => {
              if(isRead) {
                markRoomAlertAsUnread({
                  variables: {
                    alertId: alertId,
                  }
                }).then(() => {
                  setAlerts(prevAlerts => 
                    prevAlerts.map(alert => {
                      if (alert.alertId === alertId) {
                        return { ...alert, isReadByCurrentUser: false };
                      } else {
                        return alert;
                      }
                    })
                  )
                })
              }
            }}
          >
            <UndoIcon />
          </div>
        ):
        (
          <div
            className='link'
            onClick={(event) => {
              if(!isRead) {
                markRoomAlertAsRead({
                  variables: {
                    alertId: alertId,
                  }
                }).then(() => {
                  setAlerts(prevAlerts => 
                    prevAlerts.map(alert => {
                      if (alert.alertId === alertId) {
                        return { ...alert, isReadByCurrentUser: true };
                      } else {
                        return alert;
                      }
                    })
                  )
                })
              }
            }}
          >
            <CrossIcon />
          </div>
        )
      }
    </Container>
  )
}

export default AlertItem;
